import getCookies from '../getCookies';
import openKy from '../open';
import onVisibleChange from '../onVisibleChange';
import getDefer from '../getDefer';
import callNative from '../callNative';
import sleep from '../sleep';
import isInKwaiying from '../isInKwaiying';
import getUrl from '../jumpTo/getUrl';
import isLogin from '../isLogin';
import getEnv from '../getEnv';
// const loginUrl = 'kwaiying://krn?bundleId=profile&componentName=profile-login';
const closeURL = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAAG1BMVEUAAAD////////////////////////////////rTT7CAAAACXRSTlMAZj8zDRkTXQaUstWEAAAAZUlEQVQoz2OgG2AJgNBsDlABRyEIbVgBFUgUVABRzIKiQBLCEgIrgIhDmVBhhBIUBWAOWBBZCVQBQglUAUIJQgFCAEMLpqEY1mI6DMPpuDwXCPO+GFSgHRZAJbAgTIDQrA0M9AIANqYLyQ+VFPwAAAAASUVORK5CYII=';
export default async (rootTag, params = {}) => {
    const defer = getDefer();
    if (isInKwaiying()) {
        openKy(getUrl('profile', 'profile-login', params, 'rn'));
        onVisibleChange(async (visible) => {
            if (visible) {
                let result = 0;
                if (isInKwaiying()) {
                    callNative('updateCookie', { isPromise: false });
                    let userId = '';
                    // 不知道要延时多久，轮训处理，最多等1s。没有登录的情况一定会等待最大时间
                    for (let i = 0; i < 10; i++) {
                        await sleep(100);
                        userId = await getCookies('userId');
                        if (userId) {
                            result = 1;
                            break;
                        }
                    }
                }
                else {
                    const res = await isLogin();
                    result = Number(res);
                }
                defer.resolve({
                    result,
                });
            }
        }, rootTag);
    }
    else {
        const env = await getEnv();
        const successUrl = getUrl('KyLogin', 'success', params, 'web', env.type);
        const loginUrl = getUrl('KyLogin', 'index', {
            callbackUrl: successUrl,
            modal: 1,
            ...params,
        }, 'web', env.type);
        // const loginUrl =
        //     'http://localhost:8083/index.html?modal=1&callbackUrl=http%3A%2F%2Flocalhost%3A8083%2Fsuccess.html';
        // const loginUrl = 'http://localhost:8083/success.html';
        const dialog = document.createElement('div');
        // better performance then set style attributes
        // eslint-disable-next-line max-len
        dialog.style.cssText =
            'position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(20,20,20,0.8);z-index:9999;display: flex;';
        dialog.innerHTML = `<div style="position: relative;width: 80%; height: 332px;margin: auto;border-radius: 12px;background: #222222;overflow: hidden;">
            <iframe frameborder="0" style="width: 100%;height: 100%;border: none;overflow: hidden;" src=${loginUrl}>
            </iframe>
            <div style="position:absolute;top:12px;right:12px;z-index: 99;width:16px;height:16px;background-image: url(${closeURL});background-size: contain;" class="login-close"></div>
        </div>`;
        document.body.appendChild(dialog);
        const closeBtn = dialog.querySelector('.login-close');
        let receiveMessage;
        const close = (success = false) => {
            success
                ? defer.resolve({ result: 1 })
                : defer.resolve({ result: 0 });
            document.body.removeChild(dialog);
            window.removeEventListener('message', receiveMessage, false);
        };
        closeBtn?.addEventListener('click', () => close(), false);
        receiveMessage = (msg) => {
            if (msg.data?.result === 1) {
                close(true);
            }
        };
        window.addEventListener('message', receiveMessage, false);
    }
    return defer.promise;
};
